// usePopoverContext.ts
import { useContext, createContext } from 'react';

export const PopoverContext = createContext<{
  open?: boolean;
  buttonRef?: any;
  floatingStyles: any;
  refs: any; // or the appropriate type for the useFloating refs
  large: boolean;
  portal: boolean;
  fill: boolean;
  close?: () => void; // <-- Add the close method here
}>({
  open: false,
  refs: undefined,
  buttonRef: undefined,
  floatingStyles: {},
  portal: false,
  large: false,
  fill: false,
  close: () => {},
});

export default function usePopoverContext() {
  const context = useContext(PopoverContext);
  if (!context) {
    throw new Error(
      'Popover compound components cannot be rendered outside the Popover component',
    );
  }
  return context;
}
